import store from '@/store';
import { URL_DEFAULT_ICON_RECURSO } from './constants';
export function resolveIconoUrl(iconKey) {
    if (!iconKey) {
        return URL_DEFAULT_ICON_RECURSO;
    }
    const iconoUrlByCodigo = store.getters['icono/iconoUrlByCodigo'];
    return iconoUrlByCodigo.get(iconKey) ?? URL_DEFAULT_ICON_RECURSO;
}
